export default["__VITE_ASSET__UIN6jmnF__","__VITE_ASSET__j5PHdElW__"];